<template>
  <div id="app" :style="`${bg_style}`">
    <Navigation v-if="!$route.path.includes('/auth/')" />
    <el-aside v-if="user && artist_role" :class="{ toggled: is_toggled }">
      <SidebarArtist />
    </el-aside>
    <el-aside v-if="user && label_role" :class="{ toggled: is_toggled }">
      <SidebarLabel />
    </el-aside>
    <el-aside v-if="user && content_role">
      <SidebarContent />
    </el-aside>
    <el-main
      :class="{
        toggled: is_toggled,
        w100: user && !$route.path.includes('/auth/') && admin_role,
        'user-main': user && !$route.path.includes('/auth/') && !admin_role,
        'user-main-label-dash':
          user &&
          !$route.path.includes('/auth/') &&
          !$route.path.includes('/my-artists/artist') &&
          !artist_role
      }"
    >
      <el-container
        v-if="
          (user && label_role) ||
            (user && artist_role) ||
            (user && content_role)
        "
        :class="{
        'aux-container': user && $route.path.includes('content-id')
      }"
      >
        <router-view />
      </el-container>
      <div v-else>
        <router-view />
      </div>
    </el-main>
    <Footer />
    <button v-if="isRefresh" class="new-content" @click="update">
      New content is available. Click to refresh.
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

const Navigation = () => import('@/global/components/navigation/Index')
const Footer = () => import('@/global/components/Footer')
const SidebarArtist = () => import('@/global/components/SidebarArtist')
const SidebarLabel = () => import('@/global/components/SidebarLabel')
const SidebarContent = () => import('@/global/components/SidebarContent')
/*import Navigation from '@/global/components/navigation/Index'
import Footer from '@/global/components/Footer'
import SidebarArtist from '@/global/components/SidebarArtist'
import SidebarLabel from '@/global/components/SidebarLabel'
import SidebarContent from '@/global/components/SidebarContent'*/

import './assets/scss/index.scss'

export default {
  components: {
    Navigation,
    SidebarArtist,
    SidebarLabel,
    SidebarContent,
    Footer
  },

  data: () => ({
    registration: null,
    isRefresh: false,
    refreshing: false
  }),

  methods: {
    appUpdateUI: function(e) {
      this.registration = e.detail
      this.isRefresh = true
    },
    update() {
      this.isRefresh = false
      if (this.registration || this.registration.waiting) {
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
    }
  },

  computed: {
    ...mapState('auth', ['user', 'is_toggled']),
    ...mapGetters('auth', [
      'admin_role',
      'artist_role',
      'label_role',
      'content_role'
    ]),

    bg_style() {
      if (this.$route.path.includes('/auth/')) {
        return `background-image: url('https://app.syncvault.com/static/img/home/homepage-banner.jpg')`
      } else {
        return 'background-color:rgba(236, 235, 240, 72%);'
      }
    }
  },

  created() {
    document.addEventListener('serviceWorkerUpdateEvent', this.appUpdateUI, {
      once: true
    })
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  }
}
</script>

<style lang="scss" scoped>
#app {
  overflow-y: auto;
  background-image: url('assets/images/background.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  height: 100vh;
}

.user-main {
  transition: 500ms;
  top: 90px;
  padding: 55px 18px 15px;
  left: 300px;
  margin-right: 300px;
  display: grid;
  position: relative;
}

.new-content {
  float: right;
  background-color: #0e0426;
  color: white;
  padding: 20px 10px 20px 10px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  border: 2px solid #ffa400;
  border-radius: 12px;
  margin-bottom: 5px;
  margin-right: 5px;
}
@import '@/assets/scss/_responsive.scss';
</style>
